import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IModalBase } from '../../interfaces/commonInterfaces'
import moment from 'moment'

export interface ContainerState {
  containerList?: unknown
  containerOptionList?: unknown
  containerDetail?: unknown
  reloadContainerList?: string | null
  modalContainer?: IModalBase
}

const initialState: ContainerState = {
  containerList: {},
  containerOptionList: {},
  containerDetail: {},
  reloadContainerList: null,
  modalContainer: {
    visible: false,
    record: {},
  },
}

export const containerDucks = createSlice({
  name: 'container',
  initialState,
  reducers: {
    getListContainer: (state, action: PayloadAction<string | undefined>) => {
      state.containerList = { loading: true, queryStr: action.payload }
    },
    getListContainerSuccess: (state, action: PayloadAction<unknown>) => {
      state.containerList = { loading: false, ...(action.payload as object) }
    },
    getListContainerFail: (state, action: PayloadAction<unknown>) => {
      state.containerList = { loading: false, ...(action.payload as object) }
    },

    getListOptionContainer: (state, action: PayloadAction<string | undefined>) => {
      state.containerOptionList = { loading: true, queryStr: action.payload }
    },
    getListOptionContainerSuccess: (state, action: PayloadAction<unknown>) => {
      state.containerOptionList = { loading: false, ...(action.payload as object) }
    },
    getListOptionContainerFail: (state, action: PayloadAction<unknown>) => {
      state.containerOptionList = { loading: false, ...(action.payload as object) }
    },

    getDetailContainer: (state, action: PayloadAction<string | number>) => {
      state.containerDetail = { loading: true, id: action.payload }
    },
    getDetailContainerSuccess: (state, action: PayloadAction<unknown>) => {
      state.containerDetail = { loading: false, ...(action.payload as object) }
    },
    getDetailContainerFail: (state, action: PayloadAction<unknown>) => {
      state.containerDetail = { loading: false, ...(action.payload as object) }
    },

    setReloadContainerList: (state) => {
      state.reloadContainerList = String(moment())
    },
    setModalContainer: (state, action: PayloadAction<IModalBase>) => {
      state.modalContainer = action.payload
    },
  },
})

export const {
  getListContainer,
  getListContainerSuccess,
  getListContainerFail,
  getListOptionContainer,
  getListOptionContainerSuccess,
  getListOptionContainerFail,
  getDetailContainer,
  getDetailContainerSuccess,
  getDetailContainerFail,
  setReloadContainerList,
  setModalContainer,
} = containerDucks.actions

export default containerDucks.reducer
